export default "__VITE_ASSET__Eg6Hybm4__"